module.exports = "<div class=\"scroll-container\" slim-scroll>\n    <tf-open-trader-videos></tf-open-trader-videos>\n</div>";